import { WeatherForecastController } from "./weather-forecast.controller";
import "./weather-forecast.style.scss";

const weatherForecastDirective = function(): Record<string, any> {
	return {
		restrict: "E",
		scope: {
			data: "=forecastData",
			stadiumType: "=",
			dateDayBeforeMonth: "=",
			temperatureDisplay: "=",
		},
		bindToController: true,
		controller: WeatherForecastController,
		controllerAs: "wc",
		template: require("./weather-forecast.template.html"),
	};
};

export default weatherForecastDirective;